import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-video2',
  templateUrl: './video2.component.html',
  styleUrls: ['./video2.component.css']
})
export class Video2Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
